import React from 'react';
import { motion } from 'framer-motion';
import {
  ChatBubbleLeftRightIcon,
  PaintBrushIcon,
  CodeBracketIcon,
  RocketLaunchIcon,
} from '@heroicons/react/24/outline';
import { useLanguage } from '../context/LanguageContext';

const WorkProcess = () => {
  const { t } = useLanguage();

  const steps = [
    { icon: ChatBubbleLeftRightIcon, titleKey: 'process.step1.title', descKey: 'process.step1.description', number: '01' },
    { icon: PaintBrushIcon, titleKey: 'process.step2.title', descKey: 'process.step2.description', number: '02' },
    { icon: CodeBracketIcon, titleKey: 'process.step3.title', descKey: 'process.step3.description', number: '03' },
    { icon: RocketLaunchIcon, titleKey: 'process.step4.title', descKey: 'process.step4.description', number: '04' },
  ];

  return (
    <section className="py-20 md:py-28 px-4 relative overflow-hidden">
      <div className="absolute inset-0" aria-hidden="true">
        <div className="absolute inset-0 grid-pattern opacity-10" />
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <p className="eyebrow text-accent-400 text-xs mb-3">
            {t('process.label')}
          </p>
          <h2 className="text-3xl md:text-5xl font-bold mb-5">
            {t('process.title')}{' '}
            <span className="text-accent-400">
              {t('process.titleHighlight')}
            </span>
          </h2>
          <p className="text-base md:text-lg text-gray-300 max-w-2xl mx-auto">
            {t('process.subtitle')}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 25 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.12 }}
                viewport={{ once: true }}
                className="relative"
              >
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-10 left-[calc(50%+32px)] right-0 h-px bg-gradient-to-r from-white/15 to-transparent z-0" />
                )}

                <div className="surface rounded-2xl p-6 text-center relative z-10 hover:border-white/15 transition-colors duration-300 h-full">
                  <div className="w-14 h-14 rounded-2xl bg-accent-500/10 border border-accent-500/20 p-3 mx-auto mb-5">
                    <Icon className="w-full h-full text-accent-400" />
                  </div>
                  <span className="font-mono-num text-xs font-bold tracking-widest text-accent-400">
                    {step.number}
                  </span>
                  <h3 className="text-lg font-semibold text-white mt-2 mb-2">
                    {t(step.titleKey)}
                  </h3>
                  <p className="text-sm text-gray-300 leading-relaxed">
                    {t(step.descKey)}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WorkProcess;
